export default "__VITE_ASSET__DsToFk5m__"